/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContentListResponse } from '../../models/get-content-list-response';

export interface GetSectionContentListByCode$Params {

/**
 * Kod sekcie
 */
  code: string;
}

export function getSectionContentListByCode(http: HttpClient, rootUrl: string, params: GetSectionContentListByCode$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContentListResponse>> {
  const rb = new RequestBuilder(rootUrl, getSectionContentListByCode.PATH, 'get');
  if (params) {
    rb.path('code', params.code, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContentListResponse>;
    })
  );
}

getSectionContentListByCode.PATH = '/admin/menuByCode/{code}/contentList';
